import { ListItem, PaperList, ShimmerListItem } from '../styled'

const shimmerListItems = Array.from(Array(6).keys())

export const PaperListShimmer = () => {
  return (
    <PaperList>
      {shimmerListItems.map((value) => (
        <ListItem key={value}>
          <ShimmerListItem />
          <ShimmerListItem />
        </ListItem>
      ))}
    </PaperList>
  )
}
